<h1 mat-dialog-title i18n="Associate Business Title@@associateBusinessDialogTitle">Associate with business</h1>

<div mat-dialog-content>
    <p i18n="Associate Business Message@@associateBusinessDialogMessage">Associate an asset with a business.</p>
    <app-business-selection-input
    		[showAllBusinesses]="true"
            [selectedBusinesses]="data.asset.businessId"
            (valueChange)="setActiveSelection($event)"
    ></app-business-selection-input>
</div>

<div mat-dialog-actions>
    <button mat-button color="secondary" mat-dialog-close>Cancel</button>
    <button mat-button color="primary" (click)="dialogRef.close(activeSelection)"
			i18n="Associate Business Confirm@@associateBusinessDialogConfirm">Associate</button>
</div>
